import { render } from "./TableImg.vue?vue&type=template&id=bef9e582&scoped=true"
import script from "./TableImg.vue?vue&type=script&lang=js"
export * from "./TableImg.vue?vue&type=script&lang=js"

import "./TableImg.vue?vue&type=style&index=0&id=bef9e582&scoped=true&lang=less"

import exportComponent from "C:\\code\\zfb_xf_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef9e582"]])

export default __exports__